import qs from 'qs';
import axios from 'axios';
import Jsona from 'jsona';

const url = process.env.VUE_APP_API_BASE_URL;
const jsona = new Jsona();

function list(params) {
    let options = {
        params: params,
        paramsSerializer: function (params) {
            return qs.stringify(params, {encode: false});
        },
    };

    return axios.get(`${url}/stationTariffs`, options)
        .then(response => {
            return {
                list: jsona.deserialize(response.data),
                meta: response.data.meta
            };
        });
}

function get(payload) {
    const {id, ...queryParams} = payload;
    const options = {
        headers: {
            'Accept': 'application/vnd.api+json',
            'Content-Type': 'application/vnd.api+json',
        },
        params: queryParams
    };

    return axios.get(`${url}/stationTariffs/${id}`, options)
        .then(response => {
            let stationTariff = jsona.deserialize(response.data);
            delete stationTariff.links;
            console.log(stationTariff);
            return stationTariff;
        });
}


function show(payload) {
    const {id, ...queryParams} = payload;
    const options = {
        headers: {
            'Accept': 'application/vnd.api+json',
            'Content-Type': 'application/vnd.api+json',
        },
        params: queryParams
    };

    return axios.get(`${url}/stationTariffs/${id}`, options)
        .then(response => {
            let stationTariff = jsona.deserialize(response.data);
            delete stationTariff.links;
            return stationTariff;
        });
}

function add(stationTariff) {
    const payload = jsona.serialize({
        stuff: stationTariff,
        includeNames: ['station', 'tariff']
    });

    const options = {
        headers: {
            'Accept': 'application/vnd.api+json',
            'Content-Type': 'application/vnd.api+json',
        }
    };

    return axios.post(`${url}/stationTariffs?include=station,tariff`, payload, options)
        .then(response => {
            return jsona.deserialize(response.data);
        });
}

function update(stationTariff) {
    const payload = jsona.serialize({
        stuff: stationTariff,
        includeNames: []
    });

    const options = {
        headers: {
            'Accept': 'application/vnd.api+json',
            'Content-Type': 'application/vnd.api+json',
        }
    };
    return axios.patch(`${url}/stationTariffs/${stationTariff.id}`, payload, options)
        .then(response => {
            return jsona.deserialize(response.data);
        });
}

function destroy(id) {
    const options = {
        headers: {
            'Accept': 'application/vnd.api+json',
            'Content-Type': 'application/vnd.api+json',
        }
    };

    return axios.delete(`${url}/stationTariffs/${id}`, options);
}

export default {
    list,
    get,
    show,
    add,
    update,
    destroy
};

